<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<livingList></livingList>
			<div class="settlementBox">
				<livingSettlement></livingSettlement>
			</div>
		</div>
		<div class="list" v-if="type==='dingList'">
			<livingDingList></livingDingList>
		</div>
		<div class="list" v-if="type==='update'">
			<livingUpdateList></livingUpdateList>
			<div class="settlementBox">
				<livingUpdateSettlement></livingUpdateSettlement>
			</div>
		</div>
		<div class="add" v-if="type==='see'">
		</div>
	</div>
</template>
<script>
	import livingList from "./comp/living_list.vue"
	import livingSettlement from "./comp/living_settlement.vue"
	import livingDingList from "./comp/livingDing_list.vue"
	import livingUpdateList from "./comp/livingUpdate_list.vue"
	import livingUpdateSettlement from "./comp/livingUpdate_settlement.vue"
	export default {
		components:{livingList,livingSettlement,livingDingList,livingUpdateList,livingUpdateSettlement},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.living.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
